import { Link, Typography } from "@mui/material";
import { GRAPHQL_QUERY_UPCOMING_EVENTS } from "app/queries";
import DocumentContext from "components/DocumentContext";
import PageWrapper from "components/PageWrapper";
import { useCurrentServerTime } from "hooks/useCurrentServerTime";
import { EventListLoader } from "../eventDisplay/EventListLoader";
import { SessionType } from "@app/shared/types";
import { NavLink } from "features/navigation/NavLink";

export const DropInSessionsMeditationsDiscussionsPage = () => {
    const currentServerTime = useCurrentServerTime();

    return (
        <div>
            <DocumentContext title="Meditations" addBrandNameSuffix />

            <PageWrapper>
                <Typography variant="h1">Meditations</Typography>

                <Typography variant="body1">
                    <NavLink
                        to="https://cloudsangha.notion.site/Our-Session-Types-and-What-To-Expect-8a499b4161e94f63b7e8d88dc1b3f19e?pvs=4"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Get more information
                    </NavLink>{" "}
                    about our session types and formats.
                </Typography>

                <EventListLoader
                    eventsQuery={GRAPHQL_QUERY_UPCOMING_EVENTS}
                    queryOptions={{
                        variables: {
                            includeTypes: [
                                SessionType.COMMUNITY_SIT,
                                SessionType.COMMUNITY_DISCUSSION_GROUP,
                                SessionType.TEACHER_ONLY_SESSION, // These are filtered out on the back-end for members
                                SessionType.OPEN_HOUSE, // These are filtered out on the back-end for members
                            ],
                        },
                    }}
                    data-testid="dropInSessionsMeditationsDiscussionsList"
                    currentServerTime={currentServerTime}
                    splitEventsByDay={true}
                    showSpecificDate={true}
                />
            </PageWrapper>
        </div>
    );
};
